import DefaultTypography from './DefaultTypography'
import { TypesDemo } from '../../components'
import Video from '../../components/video/Video'
import BasicImage from '../../components/basicImage/BasicImage'
import InfoCard from '../../components/infoCard/InfoCard'
import Accordion from '../../components/accordion/Accordion'
import BasicButton from '../basicButton/BasicButton'
import Spacer from '../spacer/Spacer'
import CheckoutForm from '../../components/checkoutForm/CheckoutForm'
import CheckoutSuccess from '../checkoutSuccess/CheckoutSuccess'
import Checklist from '../checklist/Checklist'
import Divider from '../divider/Divider'
import BulletText from '../bulletText/BulletText'
import Stars from '../stars/Stars'

// import color from './marks/Color'
import { Color, Linker, ButtonMark, Center, InlineText, InlineImage, Bullet, ModalLink } from './marks'


export const ALL = {
    block: DefaultTypography,
    // * Handles Custom Component Types
    types: {
        demo: TypesDemo,
        video: Video,
        basicImageObject: BasicImage,
        infoCard: InfoCard,
        accordion: Accordion,
        button: BasicButton,
        spacer: Spacer,
        checkoutForm: CheckoutForm,
        checkoutSuccess: CheckoutSuccess,
        checklist: Checklist,
        divider: Divider,
        bulletText: BulletText,
        stars: Stars,
    },
    marks: {   
        center: Center,     
        color: Color,
        link: Linker,
        button: ButtonMark,
        inlineText: InlineText,
        inlineImage: InlineImage,
        bullet: Bullet,
        modalLink: ModalLink,
    }
}

export default ALL